var _rect, _ellipse, _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAgents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.505859,
    y: 0.500244,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F9FAFB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5059,
    cy: 26.3753,
    rx: 6.5,
    ry: 2.70833,
    stroke: "#404040",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5059,
    cy: 17.167,
    r: 3.25,
    stroke: "#404040",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3645 22.9351C14.0773 23.0002 12.8989 23.2375 11.9798 23.6051C11.4374 23.8221 10.9482 24.0992 10.5822 24.4453C10.2147 24.7928 9.92188 25.2617 9.92188 25.8335C9.92188 26.4054 10.2147 26.8743 10.5822 27.2218C10.9482 27.5679 11.4374 27.845 11.9798 28.062C12.496 28.2685 13.0941 28.4338 13.7472 28.5507C13.2697 28.013 12.9637 27.4186 12.8695 26.7904C12.7533 26.7519 12.6423 26.7114 12.5369 26.6693C12.0991 26.4941 11.7951 26.3044 11.6129 26.132C11.4322 25.9611 11.4219 25.86 11.4219 25.8335C11.4219 25.8071 11.4322 25.706 11.6129 25.5351C11.7951 25.3627 12.0991 25.173 12.5369 24.9978C12.7766 24.9019 13.0454 24.8148 13.3388 24.739C13.7725 24.0541 14.4708 23.4398 15.3645 22.9351Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1415 26.7904C30.0473 27.4186 29.7413 28.013 29.2638 28.5507C29.917 28.4338 30.515 28.2685 31.0312 28.062C31.5736 27.845 32.0629 27.5679 32.4288 27.2218C32.7963 26.8743 33.0891 26.4054 33.0891 25.8335C33.0891 25.2617 32.7963 24.7928 32.4288 24.4453C32.0629 24.0992 31.5736 23.8221 31.0312 23.6051C30.1121 23.2375 28.9337 23.0002 27.6465 22.9351C28.5402 23.4398 29.2385 24.0541 29.6722 24.739C29.9656 24.8148 30.2344 24.9019 30.4741 24.9978C30.9119 25.173 31.2159 25.3627 31.3981 25.5351C31.5788 25.706 31.5891 25.8071 31.5891 25.8335C31.5891 25.86 31.5788 25.9611 31.3981 26.132C31.2159 26.3044 30.9119 26.4941 30.4741 26.6693C30.3687 26.7114 30.2577 26.7519 30.1415 26.7904Z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3693 19.5547C26.1443 20.0121 25.8567 20.4332 25.5176 20.8067C25.9343 21.0362 26.4133 21.1668 26.9227 21.1668C28.5336 21.1668 29.8394 19.861 29.8394 18.2502C29.8394 16.6393 28.5336 15.3335 26.9227 15.3335C26.8172 15.3335 26.7131 15.3391 26.6105 15.35C26.7772 15.8182 26.8812 16.3161 26.9126 16.8335C26.916 16.8335 26.9194 16.8335 26.9227 16.8335C27.7051 16.8335 28.3394 17.4678 28.3394 18.2502C28.3394 19.0326 27.7051 19.6668 26.9227 19.6668C26.7264 19.6668 26.5394 19.6269 26.3693 19.5547Z",
    fill: "#404040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4008 15.35C16.2982 15.3391 16.194 15.3335 16.0885 15.3335C14.4777 15.3335 13.1719 16.6393 13.1719 18.2502C13.1719 19.861 14.4777 21.1668 16.0885 21.1668C16.598 21.1668 17.0769 21.0362 17.4937 20.8067C17.1546 20.4332 16.8669 20.0121 16.6419 19.5547C16.4719 19.6269 16.2849 19.6668 16.0885 19.6668C15.3061 19.6668 14.6719 19.0326 14.6719 18.2502C14.6719 17.4678 15.3061 16.8335 16.0885 16.8335C16.0919 16.8335 16.0953 16.8335 16.0986 16.8335C16.13 16.3161 16.2341 15.8182 16.4008 15.35Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgents);
export default __webpack_public_path__ + "static/media/icon-agents.c5231898c472ef8d22096d06557055d4.svg";
export { ForwardRef as ReactComponent };